import axios from "axios";
import qs from "qs";
import {api} from "@/plugins/util";

/**
 * 获取登录协议书列表
 */
export function getLoginAgreementList(current) {
    return axios.get(api + "/loginAgreement/getLoginAgreementList", {
        params: {
            current
        }
    })
}

/**
 * 主键id查询
 */
export function selectAgreementPrimaryKey(id) {
    return axios.get(api + "/loginAgreement/selectAgreementPrimaryKey", {
        params: {
            id
        }
    })
}

/**
 * 添加登录协议书
 */
export function addLoginAgreement(data) {
    return axios.post(api + "/loginAgreement/addLoginAgreement", data)
}

/**
 * 修改登录协议书
 */
export function updateLoginAgreement(data) {
    return axios.put(api + "/loginAgreement/updateLoginAgreement", data)
}

/**
 * 删除登录协议书
 */
export function deleteLoginAgreement(id) {
    return axios.delete(api + "/loginAgreement/deleteLoginAgreement", {
        params: {
            id
        }
    })
}

/**
 * 启用或禁用登录协议书
 */
export function enableOrDisableLoginAgreement(id) {
    return axios.get(api + "/loginAgreement/enableOrDisableLoginAgreement", {
        params: {
            id
        }
    })
}

/**
 * 获取启用的登录协议书
 */
export function getEnableLoginAgreement() {
    return axios.get(api + "/loginAgreement/getEnableLoginAgreement", {})
}
